module.exports = __webpack_public_path__ + "img/9788901086118.9c72bba6.jpg";